/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CreatePositionRequestWorkflowFactory } from '@coin/shared/core/util-models-v2';
import { CreatePositionRequestWorkflowFactoryRule } from '@coin/shared/core/util-models-v2';
import { PageOfWorkflowFactory } from '@coin/shared/core/util-models-v2';
import { PageOfWorkflowFactoryRule } from '@coin/shared/core/util-models-v2';
import { PositionRequestWorkflowFactoryRule } from '@coin/shared/core/util-models-v2';
import { UpdatePositionRequestWorkflowFactory } from '@coin/shared/core/util-models-v2';
import { UpdatePositionRequestWorkflowFactoryRule } from '@coin/shared/core/util-models-v2';
import { WorkflowFactory } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CreateWorkflowFactoryPositionRequestWorkflowFactoriesParams {
  /** The data to create the workflow-factory with. */
  createPositionRequestWorkflowFactory?: CreatePositionRequestWorkflowFactory;
}

export interface CreateWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams {
  /** The unique id of the workflow-factory to create the workflow-factory-rule for. */
  workflowFactoryId: string;
  /** The data to create the workflow-factory-rule with. */
  createPositionRequestWorkflowFactoryRule?: CreatePositionRequestWorkflowFactoryRule;
}

export interface DeleteWorkflowFactoryPositionRequestWorkflowFactoriesParams {
  /** The unique id of the workflow-factory to delete. */
  id: string;
}

export interface DeleteWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams {
  /** The unique id of the workflow-factory to delete the workflow-factory-rule of. */
  workflowFactoryId: string;
  /** The unique id of the workflow-factory-rule to delete. */
  id: string;
}

export interface PageWorkflowFactoriesPositionRequestWorkflowFactoriesParams {
  /** Query all workflow-factories with specific title. */
  titleStartsWith?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface PageWorkflowFactoryRulesPositionRequestWorkflowFactoryRulesParams {
  /** The unique id of the workflow-factory to get a page of workflow-factory-rules of. */
  workflowFactoryId: string;
  /** Query all workflow-factory-rules with titles starting with. */
  titleStartsWith?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface UpdateWorkflowFactoryPositionRequestWorkflowFactoriesParams {
  /** The unique id of the workflow-factory to update. */
  id: string;
  /** The data to update the workflow-factory with. */
  updatePositionRequestWorkflowFactory?: UpdatePositionRequestWorkflowFactory;
}

export interface UpdateWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams {
  /** The unique id of the workflow-factory to update the workflow-factory-rule of. */
  workflowFactoryId: string;
  /** The unique id of the workflow-factory-rule to update. */
  id: string;
  /** The data to update the workflow-factory-rule with. */
  updatePositionRequestWorkflowFactoryRule?: UpdatePositionRequestWorkflowFactoryRule;
}

@Injectable({
  providedIn: 'root'
})
export class ApprovalWorkflowsAdminPositionRequestService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * Creates a workflow-factory.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createWorkflowFactoryPositionRequestWorkflowFactories(
    requestParameters?: CreateWorkflowFactoryPositionRequestWorkflowFactoriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<WorkflowFactory>;
  public createWorkflowFactoryPositionRequestWorkflowFactories(
    requestParameters?: CreateWorkflowFactoryPositionRequestWorkflowFactoriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<WorkflowFactory>>;
  public createWorkflowFactoryPositionRequestWorkflowFactories(
    requestParameters?: CreateWorkflowFactoryPositionRequestWorkflowFactoriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<WorkflowFactory>>;
  public createWorkflowFactoryPositionRequestWorkflowFactories(
    requestParameters?: CreateWorkflowFactoryPositionRequestWorkflowFactoriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/approval-workflows/workflow-factories/position-request`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPositionRequestWorkflowFactory,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Creates a workflow-factory-rule for a workflow-factory.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createWorkflowFactoryRulePositionRequestWorkflowFactoryRules(
    requestParameters?: CreateWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequestWorkflowFactoryRule>;
  public createWorkflowFactoryRulePositionRequestWorkflowFactoryRules(
    requestParameters?: CreateWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequestWorkflowFactoryRule>>;
  public createWorkflowFactoryRulePositionRequestWorkflowFactoryRules(
    requestParameters?: CreateWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequestWorkflowFactoryRule>>;
  public createWorkflowFactoryRulePositionRequestWorkflowFactoryRules(
    requestParameters?: CreateWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const workflowFactoryId = requestParameters?.workflowFactoryId;
    this.checkRequired('createWorkflowFactoryRulePositionRequestWorkflowFactoryRules', { workflowFactoryId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/approval-workflows/workflow-factories/${this.configuration.encodeParam({ name: 'workflowFactoryId', value: workflowFactoryId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/position-request/rules`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPositionRequestWorkflowFactoryRule,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Deletes a workflow-factory.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteWorkflowFactoryPositionRequestWorkflowFactories(
    requestParameters?: DeleteWorkflowFactoryPositionRequestWorkflowFactoriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteWorkflowFactoryPositionRequestWorkflowFactories(
    requestParameters?: DeleteWorkflowFactoryPositionRequestWorkflowFactoriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteWorkflowFactoryPositionRequestWorkflowFactories(
    requestParameters?: DeleteWorkflowFactoryPositionRequestWorkflowFactoriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteWorkflowFactoryPositionRequestWorkflowFactories(
    requestParameters?: DeleteWorkflowFactoryPositionRequestWorkflowFactoriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteWorkflowFactoryPositionRequestWorkflowFactories', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/approval-workflows/workflow-factories/position-request/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * Deletes a workflow-factory-rule of a workflow-factory.
   * Will update all workflow-factory-rule priorities to account for the now deleted workflow-factory-rule.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteWorkflowFactoryRulePositionRequestWorkflowFactoryRules(
    requestParameters?: DeleteWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteWorkflowFactoryRulePositionRequestWorkflowFactoryRules(
    requestParameters?: DeleteWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteWorkflowFactoryRulePositionRequestWorkflowFactoryRules(
    requestParameters?: DeleteWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteWorkflowFactoryRulePositionRequestWorkflowFactoryRules(
    requestParameters?: DeleteWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const workflowFactoryId = requestParameters?.workflowFactoryId;
    const id = requestParameters?.id;
    this.checkRequired('deleteWorkflowFactoryRulePositionRequestWorkflowFactoryRules', { workflowFactoryId, id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/approval-workflows/workflow-factories/${this.configuration.encodeParam({ name: 'workflowFactoryId', value: workflowFactoryId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/position-request/rules/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * Gets a page of workflow-factories.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pageWorkflowFactoriesPositionRequestWorkflowFactories(
    requestParameters?: PageWorkflowFactoriesPositionRequestWorkflowFactoriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfWorkflowFactory>;
  public pageWorkflowFactoriesPositionRequestWorkflowFactories(
    requestParameters?: PageWorkflowFactoriesPositionRequestWorkflowFactoriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfWorkflowFactory>>;
  public pageWorkflowFactoriesPositionRequestWorkflowFactories(
    requestParameters?: PageWorkflowFactoriesPositionRequestWorkflowFactoriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfWorkflowFactory>>;
  public pageWorkflowFactoriesPositionRequestWorkflowFactories(
    requestParameters?: PageWorkflowFactoriesPositionRequestWorkflowFactoriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/approval-workflows/workflow-factories/position-request`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TitleStartsWith: requestParameters?.titleStartsWith,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * Gets a page of workflow-factory-rules of a specific workflowFactoryId.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pageWorkflowFactoryRulesPositionRequestWorkflowFactoryRules(
    requestParameters?: PageWorkflowFactoryRulesPositionRequestWorkflowFactoryRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfWorkflowFactoryRule>;
  public pageWorkflowFactoryRulesPositionRequestWorkflowFactoryRules(
    requestParameters?: PageWorkflowFactoryRulesPositionRequestWorkflowFactoryRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfWorkflowFactoryRule>>;
  public pageWorkflowFactoryRulesPositionRequestWorkflowFactoryRules(
    requestParameters?: PageWorkflowFactoryRulesPositionRequestWorkflowFactoryRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfWorkflowFactoryRule>>;
  public pageWorkflowFactoryRulesPositionRequestWorkflowFactoryRules(
    requestParameters?: PageWorkflowFactoryRulesPositionRequestWorkflowFactoryRulesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const workflowFactoryId = requestParameters?.workflowFactoryId;
    this.checkRequired('pageWorkflowFactoryRulesPositionRequestWorkflowFactoryRules', { workflowFactoryId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/approval-workflows/workflow-factories/${this.configuration.encodeParam({ name: 'workflowFactoryId', value: workflowFactoryId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/position-request/rules`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TitleStartsWith: requestParameters?.titleStartsWith,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * Updates a workflow-factory.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateWorkflowFactoryPositionRequestWorkflowFactories(
    requestParameters?: UpdateWorkflowFactoryPositionRequestWorkflowFactoriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<WorkflowFactory>;
  public updateWorkflowFactoryPositionRequestWorkflowFactories(
    requestParameters?: UpdateWorkflowFactoryPositionRequestWorkflowFactoriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<WorkflowFactory>>;
  public updateWorkflowFactoryPositionRequestWorkflowFactories(
    requestParameters?: UpdateWorkflowFactoryPositionRequestWorkflowFactoriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<WorkflowFactory>>;
  public updateWorkflowFactoryPositionRequestWorkflowFactories(
    requestParameters?: UpdateWorkflowFactoryPositionRequestWorkflowFactoriesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateWorkflowFactoryPositionRequestWorkflowFactories', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/approval-workflows/workflow-factories/position-request/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePositionRequestWorkflowFactory,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Updates a workflow-factory-rule of a workflow-factory.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateWorkflowFactoryRulePositionRequestWorkflowFactoryRules(
    requestParameters?: UpdateWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequestWorkflowFactoryRule>;
  public updateWorkflowFactoryRulePositionRequestWorkflowFactoryRules(
    requestParameters?: UpdateWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequestWorkflowFactoryRule>>;
  public updateWorkflowFactoryRulePositionRequestWorkflowFactoryRules(
    requestParameters?: UpdateWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequestWorkflowFactoryRule>>;
  public updateWorkflowFactoryRulePositionRequestWorkflowFactoryRules(
    requestParameters?: UpdateWorkflowFactoryRulePositionRequestWorkflowFactoryRulesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const workflowFactoryId = requestParameters?.workflowFactoryId;
    const id = requestParameters?.id;
    this.checkRequired('updateWorkflowFactoryRulePositionRequestWorkflowFactoryRules', { workflowFactoryId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/approval-workflows/workflow-factories/${this.configuration.encodeParam({ name: 'workflowFactoryId', value: workflowFactoryId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/position-request/rules/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePositionRequestWorkflowFactoryRule,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
